import { ButtonLink, type ButtonLinkProps } from '@commons/components/Button/ButtonLink';
import type { DrupalBlock } from '@commons/types/drupal';

// Type definition for the ButtonBlock component properties.

type Props = DrupalBlock<{
  url: string;
  text: string;
  xl?: boolean;
  variant: ButtonLinkProps['variant'];
  activeColor: ButtonLinkProps['activeColor'];
  disableScroll?: boolean;
}>;

/**
 * Button block component.
 */

const ButtonBlock = ({ content }: Props) => {
  const { url, text, xl, variant, activeColor, disableScroll = false } = content;

  return (
    <ButtonLink
      href={url}
      xl={xl}
      variant={variant}
      activeColor={activeColor}
      scroll={!disableScroll}
    >
      {text}
    </ButtonLink>
  );
};

export default ButtonBlock;
